module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-300.woff2?b871ad6e5cbe2a1c8c7362c81a234f93";